const DAY_MS = 86_400_000;

/** A time zone Intl accepts, or undefined (the browser's own zone) for a missing or unknown one. */
function zone(tz: string | null | undefined): string | undefined {
  if (!tz) return undefined;
  try {
    new Intl.DateTimeFormat('en', { timeZone: tz });
    return tz;
  } catch {
    return undefined;
  }
}

/** "Oct 16". */
export function shortDate(iso: string, lang: string, tz?: string | null): string {
  return new Intl.DateTimeFormat(lang, { month: 'short', day: 'numeric', timeZone: zone(tz) }).format(new Date(iso));
}

/** "Oct 16, 2026". */
export function fullDate(iso: string, lang: string, tz?: string | null): string {
  return new Intl.DateTimeFormat(lang, { month: 'short', day: 'numeric', year: 'numeric', timeZone: zone(tz) }).format(new Date(iso));
}

/** "9:00 AM". */
export function timeOfDay(iso: string, lang: string, tz?: string | null): string {
  return new Intl.DateTimeFormat(lang, { hour: 'numeric', minute: '2-digit', timeZone: zone(tz) }).format(new Date(iso));
}

/** Whether the zone is one the page can name as "your business time". */
export const hasKnownZone = (tz: string | null | undefined): boolean => zone(tz) !== undefined;

/** Whole days until `iso` (rounded down: "6 days left" until the last day), 0 when it is under a day or past. */
export function daysLeft(iso: string, now: number = Date.now()): number {
  return Math.max(0, Math.floor((new Date(iso).getTime() - now) / DAY_MS));
}

export function money(cents: number, currency: string, lang: string): string {
  try {
    return new Intl.NumberFormat(lang, { style: 'currency', currency }).format(cents / 100);
  } catch {
    return new Intl.NumberFormat(lang).format(cents / 100);
  }
}
